import { render } from "./GoalKRSortOrderActivity.vue?vue&type=template&id=f8240a00"
import script from "./GoalKRSortOrderActivity.vue?vue&type=script&lang=js"
export * from "./GoalKRSortOrderActivity.vue?vue&type=script&lang=js"
script.render = render

export default script